import { render } from "./states-table.vue?vue&type=template&id=019b34f8"
import script from "./states-table.vue?vue&type=script&lang=js"
export * from "./states-table.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__